import PropTypes from 'prop-types';
import './Pagination.css';

/**
 * Simple page-based pagination for DRF paginated responses
 */
const Pagination = ({
  currentPage,
  totalCount,
  pageSize = 20,
  onPageChange,
  className = '',
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  if (totalPages <= 1) return null;

  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalCount);

  return (
    <div className={`pagination ${className}`}>
      <span className="pagination__info">
        {startItem}&ndash;{endItem} of {totalCount}
      </span>
      <div className="pagination__controls">
        <button
          type="button"
          className="pagination__btn"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
          aria-label="Previous page"
        >
          &lsaquo; Prev
        </button>
        <span className="pagination__page">
          {currentPage} / {totalPages}
        </span>
        <button
          type="button"
          className="pagination__btn"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          aria-label="Next page"
        >
          Next &rsaquo;
        </button>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default Pagination;
